export const MaterialName = "VEC_MKB_094";
export const SizeCode = "VEC_BGR_094";
export const Coating = "VEC_BSCH_094";
export const Preload = "VEC_VSP_094";
export const Accuracy = "VEC_GEN_094";
export const CarriageDesign = "VEC_WAU_094";
export const LocatingFace = "VEC_ANS_094";

export const DesignType_MaterialName = "VB_MKB_094";
export const DesignType_SizeCode = "VB_BGR_094";
export const DesignType_Version = "VB_VER_094";

export const GreasingPerGreaseGroup = "VEC_BLT_094";

export const StandardKits = "VEC_SAE_094"; // S - Standard & details not editable; N - Editable

export const KitsLeft = "VEC_KLI_094";
export const KitsCenter = "VEC_KMI_094";
export const KitsRight = "VEC_KRE_094";

export const LubricationConnectorOrientation = "VEC_SZ_094"; // Included, installed...
export const LubricationConnectorPosition = "VEC_SAR_094"; // Top middle bottom
export const LubricationConnector = "VEC_SA_094";
export const LubricationConnectorAlignment = "VEC_SW_094";

export const LubricationConnectorType = "VEC_SG_094";
